export const RouterKeys = {
    AUTH: {
        LOGIN: '/',
        NEW_PASSWORD: '/new_password',
        FORGOT_PASSWORD: '/forgot_password',
        VERIFICATION: '/verification',
        CONFIRM_PASSWORD: '/confirmed_password',
    },
    NON_Auth: {
        DASHBOARD: '/dashboard',
        USERS: '/user',
        USER_Detail: '/user_detail/:userId',
        ONBOARDING: '/onBoarding',
        ONBOARDING_DETAIL: '/onBoardingDetail/:id',
        CONTACT_US: '/contact_us',
        FAQ: '/faq',
        TERMS_OF_SERVICES: '/terms_of_Services',
        PRIVACY_POLICY: '/privacy_Policy',
        CHANGE_PASSWORD: '/change_password',
        MY_PROFILE:'/my_profile',
        EDIT_PROFILE:'/edit_profile'
    },

}